/**
 * One number both processes agree on — a `cf_clearance` cookie is rejected
 * if the two claim different majors (DEC-047). Moves only with the exact
 * `playwright` pin (DEC-054); `//#check` fails the build if they disagree.
 */
export const TARGET_CHROMIUM_MAJOR = 149;

/** Every Chrome profile this project's pinned `impit` knows how to
 *  impersonate — its own `Browser` union exists only in TypeScript, not at
 *  runtime, so the list is kept here by hand. */
export const IMPIT_CHROME_MAJORS = [
  100, 101, 104, 107, 110, 116, 124, 125, 131, 136, 142, 151,
] as const;

/** The impit Chrome profile closest to `major`, by plain distance rather than
 *  floored — DEC-047 measured a two-major gap surviving and a seven-major one
 *  rejected. */
export function nearestImpitChromeProfile(major: number = TARGET_CHROMIUM_MAJOR): string {
  const nearest = IMPIT_CHROME_MAJORS.reduce((best, candidate) =>
    Math.abs(candidate - major) < Math.abs(best - major) ? candidate : best,
  );
  return `chrome${nearest}`;
}
